define(['jquery'],
    function($) {

        return {'init': function() {
            $('[data-toggle="tooltip"]').tooltip();

            $('.copy_js').on('click', function (e) {
                let $temp = $("<textarea>");
                $("body").append($temp);
                $temp.val($(e.target).data('key')).select();
                document.execCommand("copy");
                $temp.remove();
                let restore = $('.copy_js').text();
                $('.copy_js').html('<i class="glyphicons glyphicons-ok"></i> Copied!');
                setTimeout(function () {
                    $('.copy_js').text(restore);
                }, 1500);
            });

        }};

    }
);
